<template>
  <main class="l-main p-contentrewrite">
    <TitleMain icon="contentplans">
      <span class="title">AIリライト提案 (Beta)</span>
      <span class="description">
        チャットAIの提案内容を基に、<br />
        上位を目指せる＝ユーザーにとって価値があるコンテンツに改善しましょう。
      </span>
    </TitleMain>
    <div class="l-container">
      <div class="l-toolBlock">
        <ButtonToProjects />
        <Breadcrumb />
      </div>
      <div class="p-contentrewrite-input l-block">
        <div class="p-contentrewrite-usage">
          <p>
            あと
            <span class="c-text--bold">{{
              usage.usageLimit - usage.usage
            }}</span>
            回利用できます<span class="c-text--neutral"
              >(月間{{ usage.usageLimit }}回/毎月1日に回数が戻ります)</span
            >
          </p>
        </div>
        <div class="p-contentrewrite-hint">
          リライトをするキーワードとURLは<router-link
            :to="{
              name: 'siteImportantKeywordActions'
            }"
            ><span @click="sendToSiteImportantKeywordEvent"
              >成果チェック</span
            ></router-link
          >もしくは<router-link
            :to="{
              name: 'taskList'
            }"
            ><span @click="sendToTaskListEvent">タスクリスト</span></router-link
          >から選びましょう！
        </div>
        <FormPostContent
          :isProcessing="token.isProcessing || headings.isLoading"
          :isUsageLimited="isUsageLimited"
          @submit="submit"
        />
      </div>
      <div v-if="hasError" class="p-contentrewrite-error">
        <div class="p-contentrewrite-error__image">
          <img
            src="@/assets/img/img-advice-question.svg"
            width="106"
            height="80"
            alt=""
          />
        </div>
        <h2 class="p-contentrewrite-error__title">
          申し訳ございませんが、お探しのページが表示できませんでした。
        </h2>
        <ul class="p-contentrewrite-error__list c-text--neutral">
          <li>URLに誤りがないかご確認の上、正しいURLを入力してください</li>
          <li>
            URLが合っている場合は、時間をあけてから再度アクセスしてください
          </li>
        </ul>
      </div>
      <div
        v-else-if="headings.isLoaded"
        class="p-contentrewrite-output l-block"
      >
        <div class="p-contentplans-writing__content">
          <AiContainer>
            <div class="p-contentplans-writing__inner">
              <section>
                <div class="p-contentplans-writing__header">
                  <h2 class="p-contentplans-writing__title--sub">
                    独自性に関する見出しのヒント
                  </h2>
                </div>
                <div class="p-contentplans-writing-ai__content">
                  <div class="p-contentplans-writing-ai-phase">
                    <Advice img="pencil" priority="low-gray">
                      <p>
                        AIを利用してコンテンツ構成案の改善をお手伝いします。<br />
                        <strong
                          >AIを利用しているため、いつも完璧なものを提案できるわけではありません。<br />あくまでも参考程度に留めて、最終的にはご自身で必ず修正してください。</strong
                        >
                      </p>
                    </Advice>
                    <AiHeadings
                      :project="project"
                      :keyword="params.keyword"
                      :token="token.data"
                      @fetched="fetchUsage"
                    />
                  </div>
                </div>
              </section>
              <section v-if="enabledContentRewriteSummaryProposalHeadings">
                <div class="p-contentplans-writing__header">
                  <h2 class="p-contentplans-writing__title--sub">
                    網羅性に関する見出しのヒント
                  </h2>
                </div>
                <div class="p-contentplans-writing-ai__content">
                  <div class="p-contentplans-writing-ai-phase">
                    <SummaryProposalHeadings
                      :project="project"
                      :keyword="params.keyword"
                      :url="params.url"
                      :token="token.data"
                      :createdAt="serps.date"
                      @fetched="fetchUsage"
                    />
                  </div>
                </div>
              </section>
              <Serps
                :createdAt="serps.date"
                :errorAddHeading="errorAddHeading"
                :keyword="params.keyword"
                :project="project"
                :isEditMode="true"
                @addHeading="addUserHeading"
              >
                <Advice img="pencil" priority="low-gray">
                  <p>
                    上位ページのタイトル・ディスクリプション・見出しテキストを参考に、<span
                      class="c-text--bold"
                      >網羅性の観点として上位表示ページに共通する要素を入れられているか</span
                    >を確認し、見出し構成案を完成させましょう。
                  </p>
                </Advice>
              </Serps>
            </div>
          </AiContainer>
          <UserContainer>
            <div class="p-contentplans-writing__inner">
              <section>
                <div class="p-contentplans-writing__header">
                  <h2 class="p-contentplans-writing__title">
                    改善したいページの構成案を編集する
                  </h2>
                </div>
                <div class="p-contentplans-writing-user__content">
                  <UserHeadings
                    :errorAddHeading="errorAddHeading"
                    :errors="error.headings"
                    :h1="params.h1"
                    :headings="params.headings"
                    :headingsLength="headingsLength"
                    isEditMode
                    ref="userHeadings"
                    @addHeading="addUserHeading"
                    @inputHeading="inputUserHeading"
                    @insertHeading="insertUserHeading"
                    @removeHeading="removeUserHeading"
                  >
                    <UserHeadingsH1 v-model="params.h1" :error="error.h1" />
                  </UserHeadings>
                  <UserDescription
                    v-model="params.description"
                    :error="error.description"
                    :maxLength="maxLength.description"
                    isEditMode
                  />
                  <UserTitle
                    v-model="params.title"
                    :error="error.title"
                    :maxLength="maxLength.title"
                    isEditMode
                  />
                  <UserAdvice />
                </div>
                <div class="p-contentplans-writing-user__footer">
                  <ButtonRectangle
                    priority="middle"
                    iconLeft="download"
                    :disabled="isDisabledDownloadButton"
                    @click="downloadFile"
                  >
                    テキストダウンロード
                  </ButtonRectangle>
                </div>
              </section>
            </div>
          </UserContainer>
        </div>
      </div>
      <div v-else-if="isShowSample" class="p-contentrewrite-output-sample">
        <img
          class="p-contentrewrite-output-sample__img"
          width="100%"
          src="@/assets/img/content-rewrite/img-output-sample.png"
          alt="AIリライト提案出力サンプル"
        />
        <div class="p-contentrewrite-output-sample__overlay" />
      </div>
    </div>
  </main>
</template>

<script>
import Advice from '@/components/Advice';
import AiContainer from '@/components/contentPlans/writing/AiContainer';
import AiHeadings from '@/components/contentRewrite/AiHeadings';
import Breadcrumb from '@/components/Breadcrumb';
import ButtonRectangle from '@/components/ButtonRectangle';
import ButtonToProjects from '@/components/ButtonToProjects';
import FormPostContent from '@/components/contentRewrite/FormPostContent';
import Serps from '@/components/contentPlans/writing/Serps';
import SummaryProposalHeadings from '@/components/contentRewrite/SummaryProposalHeadings';
import TitleMain from '@/components/TitleMain';
import UserAdvice from '@/components/contentPlans/writing/UserAdvice';
import UserContainer from '@/components/contentPlans/writing/UserContainer';
import UserDescription from '@/components/contentPlans/writing/UserDescription';
import UserHeadings from '@/components/contentPlans/writing/UserHeadings';
import UserHeadingsH1 from '@/components/contentPlans/writing/UserHeadingsH1';
import UserTitle from '@/components/contentPlans/writing/UserTitle';
import FeatureFlag from '@/featureFlag';
import axios from 'axios';
import Amplitude from '@/amplitude';
import utils from '@/utils';
import Validation from '@/validation';
import { v4 as uuidv4 } from 'uuid';

const maxLength = {
  title: 100,
  description: 300,
  heading: 100,
  headings: 100
};

export default {
  props: {
    project: {
      type: Object,
      required: true
    }
  },
  components: {
    Advice,
    AiContainer,
    AiHeadings,
    Breadcrumb,
    ButtonRectangle,
    ButtonToProjects,
    FormPostContent,
    Serps,
    SummaryProposalHeadings,
    TitleMain,
    UserAdvice,
    UserContainer,
    UserDescription,
    UserHeadings,
    UserHeadingsH1,
    UserTitle
  },
  data() {
    return {
      error: {
        title: '',
        description: '',
        h1: '',
        headings: {}
      },
      params: {
        keyword: '',
        url: '',
        title: '',
        description: '',
        h1: '',
        headings: []
      },
      headings: {
        data: null,
        isLoaded: false,
        isLoading: false
      },
      serps: {
        date: this.$options.filters.dateText(new Date(), 'YYYY-MM-DD')
      },
      token: {
        data: null,
        isProcessed: false,
        isProcessing: false
      },
      usage: {
        usage: 0,
        usageLimit: 0
      },
      cancelToken: {
        headings: null,
        usage: null
      }
    };
  },
  computed: {
    enabledContentRewrite() {
      return FeatureFlag.getFlag('CONTENT_REWRITE');
    },
    enabledContentRewriteSummaryProposalHeadings() {
      return FeatureFlag.getFlag('CR_SUMMARY_HEADINGS');
    },
    errorAddHeading() {
      if (this.headingsLength.h1234 >= this.maxLength.headings) {
        return `見出しはh4も含めて${this.maxLength.headings}個までしか追加できません`;
      }
      return '';
    },
    headingsLength() {
      const headings = this.params.headings;
      // h1 = h1の固定枠1個 + headings内のh1の数
      const h1 = 1 + headings.filter(item => item.level === 'h1').length;
      const h2 = headings.filter(item => item.level === 'h2').length;
      const h3 = headings.filter(item => item.level === 'h3').length;
      const h123 = h1 + h2 + h3;
      // h1234 = h1の固定枠1個 + headingsの数
      const h1234 = 1 + headings.length;
      return { h1, h2, h3, h123, h1234 };
    },
    maxLength() {
      return maxLength;
    },
    hasError() {
      return (!this.token.data && this.token.isProcessed) ||
        (!this.headings.data && this.headings.isLoaded)
        ? true
        : false;
    },
    isDisabledDownloadButton() {
      return this.error.title ||
        this.error.description ||
        this.error.h1 ||
        Object.keys(this.error.headings).length ||
        this.headingsLength.h1234 > this.maxLength.headings
        ? true
        : false;
    },
    isUsageLimited() {
      return this.usage.usage >= this.usage.usageLimit;
    },
    isShowSample() {
      return !(
        this.hasError ||
        this.headings.isLoaded ||
        this.headings.isLoading ||
        this.token.isProcessed ||
        this.token.isProcessing
      );
    }
  },
  watch: {
    'params.title': {
      handler(value) {
        this.error.title = new Validation()
          .maxLength(maxLength.title)
          .test(value);
      },
      immediate: true
    },
    'params.description': {
      handler(value) {
        this.error.description = new Validation()
          .maxLength(maxLength.description)
          .test(value);
      },
      immediate: true
    },
    'params.h1': {
      handler(value) {
        this.error.h1 = new Validation()
          .maxLength(maxLength.heading)
          .test(value);
      },
      immediate: true
    },
    'params.headings': {
      handler(headings) {
        const errors = {};
        // 100個以上追加できないはずだが101個以上の場合はエラーにする（+1はh1の分）
        if (headings.length + 1 > this.maxLength.headings) {
          errors.maxLength = `${this.maxLength.headings}個以内にしてください`;
        }
        headings.forEach(heading => {
          const error = new Validation()
            .maxLength(maxLength.heading)
            .test(heading.value);

          if (error) {
            errors[heading.id] = error;
          }
        });
        this.error.headings = errors;
      },
      immediate: true
    }
  },
  created() {
    if (!this.enabledContentRewrite) {
      this.$router.replace({ name: 'projects' });
      return;
    }
    this.fetchUsage();
  },
  beforeDestroy() {
    if (this.cancelToken.headings) {
      this.cancelToken.headings.cancel();
    }
    if (this.cancelToken.usage) {
      this.cancelToken.usage.cancel();
    }
  },
  methods: {
    fetchUsage() {
      this.cancelToken.usage = axios.CancelToken.source();
      return axios
        .get(
          `${process.env.VUE_APP_API_BASE_URL}/beta/projects/${this.project.id}/usages/content-rewrite`,
          {
            headers: {
              Authorization: `Bearer ${this.auth.idToken}`,
              'X-From': location.href
            },
            cancelToken: this.cancelToken.usage.token
          }
        )
        .then(response => {
          this.usage = response.data;
        })
        .catch(() => {});
    },
    async fetchHeadings(url) {
      this.headings.isLoading = true;
      this.cancelToken.headings = axios.CancelToken.source();

      const params = { url, token: this.token.data };
      const response = await axios
        .post(
          `${process.env.VUE_APP_API_GATEWAY_BETA_BASE_URL}/beta/projects/${this.project.id}/content-headers`,
          params,
          {
            headers: {
              Authorization: `Bearer ${this.auth.idToken}`,
              'X-Api-Key': process.env.VUE_APP_API_GATEWAY_BETA_KEY,
              'X-From': location.href
            },
            cancelToken: this.cancelToken.headings.token
          }
        )
        .then(response => response)
        .catch(() => null);

      if (response && response.data.status === 200) {
        const flattenHeadings = utils.getFlattenHeadings(
          response.data.headerStructures
        );
        // 上位2ページ以上には共通してあるものの、自社コンテンツにはない見出しを抽出する用のデータ
        this.headings.data = flattenHeadings;

        // 見出し構成案を編集する用のデータ（h1～h4のみ）
        const headings = [];
        flattenHeadings.forEach(item => {
          if (!/^h[1-4]$/.test(item.type)) return;
          headings.push({ id: uuidv4(), level: item.type, value: item.text });
        });

        if (headings[0] && headings[0].level === 'h1') {
          this.params.h1 = headings[0].value;
          this.params.headings = headings.slice(1);
        } else {
          this.params.h1 = '';
          this.params.headings = headings;
        }
        this.params.title = response.data.title || '';
        this.params.description = response.data.description || '';
      }

      this.headings.isLoading = false;
      this.headings.isLoaded = true;
    },
    postContent(keyword) {
      const params = { keyword };

      return axios
        .post(
          `${process.env.VUE_APP_API_BASE_URL}/beta/projects/${this.project.id}/content-rewrite`,
          params,
          {
            headers: {
              Authorization: `Bearer ${this.auth.idToken}`,
              'X-From': location.href
            }
          }
        )
        .then(response => {
          this.token.data = response.data.token;
        })
        .catch(() => {
          this.token.data = null;
        });
    },
    async submit(params) {
      this.token.isProcessing = true;

      await this.fetchUsage();

      if (this.isUsageLimited) {
        this.token.isProcessing = false;
        return;
      }

      this.reset(); //初期化
      this.params.keyword = params.keyword;
      this.params.url = params.url;

      await this.postContent(params.keyword);

      if (this.token.data) {
        this.fetchHeadings(params.url);
      }

      this.token.isProcessing = false;
      this.token.isProcessed = true;
    },
    reset() {
      this.params = {
        keyword: '',
        url: '',
        title: '',
        description: '',
        h1: '',
        headings: []
      };
      this.headings.data = null;
      this.headings.isLoaded = false;
      this.token.data = null;
      this.token.isProcessed = false;
    },
    addUserHeading(level, value) {
      this.params.headings.push({ id: uuidv4(), level, value });
      this.$refs.userHeadings.focusLastInput();
      this.$refs.userHeadings.scrollToEnd();
    },
    inputUserHeading(id, level, value) {
      const index = this.params.headings.findIndex(item => item.id === id);
      this.params.headings.splice(index, 1, { id, level, value });
    },
    insertUserHeading(id, level, value) {
      const index = this.params.headings.findIndex(item => item.id === id);
      if (index !== -1) {
        this.params.headings.splice(index + 1, 0, {
          id: uuidv4(),
          level,
          value
        });
        // <UserHeadingsListItem />のkeyをitem.idにしているので、items[index+1]のinputにフォーカスしようとしてもうまくいかない
        // 配列の途中にinsertしてもVueの内部的には最後に追加される
        this.$refs.userHeadings.focusLastInput();
      }
    },
    removeUserHeading(id) {
      const index = this.params.headings.findIndex(item => item.id === id);
      this.params.headings.splice(index, 1);
    },
    downloadFile() {
      if (this.isDisabledDownloadButton) return;

      const keyword = `キーワード「${this.params.keyword}」`;
      const url = `URL\n${this.params.url}`;
      const title = `タイトル案\n${this.params.title}`;
      const description = `ディスクリプション案\n${this.params.description}`;

      const h1 = this.params.h1 ? `h1: ${this.params.h1}\n` : ``;
      const h1234 = this.params.headings
        .filter(heading => heading.value)
        .map(item => {
          const depth = parseInt(item.level.slice(1)) - 1;
          return `${'-'.repeat(depth)}${item.level}: ${item.value}`;
        })
        .join('\n');
      const headings = `見出し構成案\n${h1}${h1234}`;

      const data = [keyword, url, title, description, headings].join('\n\n');
      const date = utils.formatDate(new Date(), 'YYYY年MM月DD日');
      const fileName = `AIリライト提案_${this.params.keyword}_${date}_${this.project.name}.txt`;
      utils.downloadFile(data, fileName);
      Amplitude.postLogEvent('DownloadContentRewritePlotTextBeta');
    },
    sendToTaskListEvent() {
      Amplitude.postLogEvent('ClickLink to TaskList - ContentRewriteBeta');
    },
    sendToSiteImportantKeywordEvent() {
      Amplitude.postLogEvent(
        'ClickLink to SiteImportantKeyword - ContentRewriteBeta'
      );
    }
  }
};
</script>
